module.exports = "/_next/static/images/wrench-monotone-7df360cd2344396b23a16e13630044ab.svg";